import { getLocalStorageAsBoolean } from '@/utils/local-storage'

// Global testing flag to disable user balance fetch
// Reads from localStorage key: 'TESTING_DISABLE_BALANCE_FETCH'
export const TESTING_DISABLE_BALANCE_FETCH: boolean = getLocalStorageAsBoolean(
  'TESTING_DISABLE_BALANCE_FETCH',
  false,
)
